import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import type { RmSurveyQuestion } from '@/utils/realtime-transfer/rmSurvey'


export default /*#__PURE__*/_defineComponent({
  __name: 'RmSurveyOptionList',
  props: {
    question: null,
    selected: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({ (e: 'select', code: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  question: RmSurveyQuestion
  selected: string[]
};




const isMultiple = computed(() => props.question.answerType === 'multiple')

return { __sfc: true,props, emit, isMultiple }
}

})